/**
 * @see CMDP_SSTATUS
 */
export enum EnumStreamStatusType {
  /**
   * @deprecated/obsolete
   */
  AUDIO_DEVICE_ERROR = "AUDIO_DEVICE_ERROR",
  /**
   * @deprecated/obsolete
   */
  AUDIO_DEVICE_FROZEN = "AUDIO_DEVICE_FROZEN",
  /**
   * @deprecated/ obsolete, ignored
   */
  AUDIO_DEVICE_MUTED = "AUDIO_DEVICE_MUTED",
  /**
   * @deprecated/ obsolete, ignored
   */
  AUDIO_DEVICE_UNMUTED = "AUDIO_DEVICE_UNMUTED",
  /**
   * @deprecated/ obsolete
   */
  BITRATE = "BITRATE",
  /**
   * @deprecated/ obsolete
   */
  CPU_OVERLOAD = "CPU_OVERLOAD",
  /**
   * @deprecated/ obsolete
   */
  DROPPED_AUDIO_FRAMES = "DROPPED_AUDIO_FRAMES",
  /**
   * @deprecated/ obsolete
   */
  DROPPED_VIDEO_FRAMES = "DROPPED_VIDEO_FRAMES",
  /**
   * @deprecated/ obsolete
   */
  VIDEO_DEVICE_ERROR = "VIDEO_DEVICE_ERROR",
  /**
   * @deprecated/ obsolete
   */
  VIDEO_DEVICE_FROZEN = "VIDEO_DEVICE_FROZEN",
  PROXY_STREAM_INFO = "PROXY_STREAM_INFO", // client provided info
  PROXY_STATE_INFO = "PROXY_STATE_INFO", // client provided info, JSON.stringify({isTyping: true})
  WEBRTC_STATS = "WEBRTC_STATS", // value is browser related JSON.stringify(RTCStatsReport()) return of RTCPeerConnection.getStats()
}
